import { Draft, PayloadAction } from '@reduxjs/toolkit'
import { filter } from 'lodash'

import { LabelingState } from '@/stores/slices/Labeling/types'

export const TEMP_COMMENT_OBJECT_ID = 'temp-comment-id'

export const commentReducers = {
  // UI에 임시 코멘트 생성
  createTempComment: (state: Draft<LabelingState>, action: PayloadAction<{
    region: { x: number, y: number }
  }>) => {
    const labelingItemId = state.files[state.currentIndex]?._id

    if (labelingItemId) {
      // 처음 생성시 초기화 배열 초기화
      if (!state.comments[labelingItemId]) {
        state.comments[labelingItemId] = []
      }
      // 생성중인 임시코멘트가 있는 경우, 추가로 생성되지 않도록 방지
      const createdTempComment = state.comments[labelingItemId].find((o) => o._id === TEMP_COMMENT_OBJECT_ID)
      if (!createdTempComment) {
        state.comments[labelingItemId].push({
          _id: TEMP_COMMENT_OBJECT_ID, // 서버 보내기전, 임시 아이디 부여
          labelingItemId,
          isConfirm: false, // 초기값
          region: action.payload.region,
          comments: [], // 초기값
          createdAt: new Date(), // 초기값
        })
      }
    }
  },
  // UI에 임시 코멘트 제거
  deleteTempComment: (state: Draft<LabelingState>, action: PayloadAction<{ labelingItemId: string }>) => {
    const labelingItemId = action.payload.labelingItemId ?? ''

    if (labelingItemId) {
      state.comments[labelingItemId] = filter(state.comments[labelingItemId], (o) => o._id !== TEMP_COMMENT_OBJECT_ID)
    }
  },
}
